import React from 'react'
import { AppContent, AppSidebar, AppFooter, AppHeader } from '../components/index'
const CustomerLayout = () => {
  return (
    <div>
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100 bg-light">
        <AppHeader />
        <div className="body flex-grow-1" style={{padding:'8px'}}>
          <AppContent />
        </div>
        <AppFooter />
      </div>
    </div>
  )
}

export default CustomerLayout